var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{class:{ on: !_vm.up },attrs:{"d":"M17 9l-5-5-5 5z"}}),_c('path',{class:{ on: !_vm.down },attrs:{"d":"M7 15l5 5 5-5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }